var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopicTipsImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 192.23 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-2{clip-rule:evenodd;}.cls-3{clip-path:url(#clip-path);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{fill:#fff;fill-rule:evenodd;}.cls-6{clip-path:url(#clip-path-3);}.cls-7{fill:#f6f7f8;}.cls-8{font-size:10px;font-family:Muli;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(126.16 3)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 65,
    height: 40
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(126.16 3)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 65.08,
    height: 39.04
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(126.16 3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6,27.51a2,2,0,0,1-2-2V4A2,2,0,0,1,6,2H59.08a2,2,0,0,1,2,2V25.51a2,2,0,0,1-2,2H37.65l-3.5,4.72a2,2,0,0,1-2.8.42,2.09,2.09,0,0,1-.42-.42l-3.5-4.72Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("image", {
    x: 126.16,
    y: 3,
    width: 65,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAAAoCAYAAAChDJfXAAAACXBIWXMAAAsSAAALEgHS3X78AAACOklEQVRoQ+2a3W6DMAxGTzq2vf/bbmPUuyBf4hh6UxgaLJ9khYafxKeOkRySmQGQUkq0ir/PLlt0ZOeTmXkAyRlcC4RRQZRjM7Po8C3YlSDcmR2/OzOAIV8gAC+5b8jHN3f+rNK/fgcm4DtbiYoIYQDesgnEmQFIHsBX7rPcx0DNAS/AKzOA99xeDcJX+H1nJRI8CA/hzCC0HLQEJupST9DmBA9Cpkg5u5QEfa4rb0JBwHfSvh2uACH60/il7O91BacfadW3NQj/Th0CHQLQIQAdAtAhAB0C0CEAHQLQIQAdAtAhAB0C0CEA6xAW9fkLadU3D8FfYM7OrujLwi9VlnxZ2luKNzyp9KBdkz1ot0j+lOKqM3x5TUXIb2BknqhAPCt/r8p2vvXyE/MTxbXPypfcJyoMyNVmP7DK0oqAveqMsYirZ2s5xjlokmWXaIP0bPk25uNFJGjw0d04ss++gyD63a3XcF4AFIWaqEBskQes5ysiFstBIKDW5veKAkHQnkY8b9TdIZmf6B7R4PPCaiRoENG/MU9iKwBoIRT6WUbNPSOz8x/sDwHaXFOWmZnZYGaWt+Y12FpC3AojsQQAdRxB+MymkN2aE+K9FlogR0L5WKHCWFy4Uf65XhNz1CkfKXEtktfeks/Q5oTmxJ7K34DEBGfULbFHSfHX5uTVQPhlaS1Kyj2KkslZWa8coEMghLzjk5OSpoVzhzgvpYNgA8Rvo3wLwfmjogAOhgCsfSXX6EjnpcMh/EX9AI6JIHL6OrZzAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M-124.16,27.51a2,2,0,0,1-2-2V4a2,2,0,0,1,2-2h53.08a2,2,0,0,1,2,2V25.51a2,2,0,0,1-2,2H-92.51L-96,32.23a2,2,0,0,1-2.8.42,1.81,1.81,0,0,1-.41-.42l-3.5-4.72Z",
    transform: "translate(126.16 3)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 125.16,
    width: 67.08,
    height: 41.04
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(141.22 20.65)"
  }, "Images")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicTipsImages);
export default __webpack_public_path__ + "static/media/TopicTips_Images.e997d49a065e13e5c5ad0fd2a5cead3f.svg";
export { ForwardRef as ReactComponent };